<!-- 头部 -->
<template>
    <div class='head'>
        <div class="headerS">
            <div>
                <img @click="skip('/index')" src="../assets/img/logo.png" alt="PAPER联盟">
            </div>
            <ul>
                <li v-for="(item , index) in lidata" @click="skip(item.path)" :class="step == index? 'active':''" :key="index">{{item.name}}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        step: {
          type: String,
          required: '0'
        },
    },
    data () {
        return {
            lidata: [
                {
                    name:'提交打印',
                    path: '/index'
                },
                // {
                //     name:'价格查询',
                //     path: '/confirm'
                // },
                {
                    name:'订单查询',
                    path: '/inquire'
                }
            ]
        }
    },
    methods: {
        skip(e) {
            if(this.$router.currentRoute.path == e) return 
            this.$router.push(e) 
        }
    }
}
</script>

<style lang='less' scoped>
    .headerS {
        max-width: 1250px;
        margin: auto;
        line-height: 60px;
        height: 100%;
        font-size: 14px;
        div {
            float: left;
            line-height: 60px;
            height: 100%;
          img{
            vertical-align: middle;
            position: relative;
            left: -5px;
          }
        }
        ul {
            float: right;
            margin: 0;
            padding: 0;
            li {
                float: left;
                margin-left: 50px;
              cursor: pointer;
            }
          .active{
            color: #126eac;
          }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/head.vue